import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Cookies from "js-cookie";
import Button from "../../../components/button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAuthStates,
  getUserState,
  setLogout,
} from "../../../redux/features/auth-slice";
import paths from "../../../navigation/paths";
import { adminCat, cookieName } from "../../../core/utils/constants";
import { AppDispatch } from "../../../redux/store";
import { clearOtherStates } from "../../../redux/features/other-slice";
import { clearTaskStates } from "../../../redux/features/task-slice";
import {
  clearCommonStates,
  setErrorState,
} from "../../../redux/features/common-slice";
import { clearUserStates, UserRole } from "../../../redux/features/user-slice";
import { clearReportStates } from "../../../redux/features/report-slice";
import { clearWeeklySummaryStates } from "../../../redux/features/weekly-summary-slice";
import { clearDReportStates } from "../../../redux/features/design-report-slice";
import { clearMisaStates } from "../../../redux/features/misa-slice";
import { clearDocumentStates } from "../../../redux/features/document-slice";

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const user = useSelector(getUserState).data;

  useEffect(() => {
    if (Cookies.get(cookieName) === undefined) {
      dispatch(setLogout());
    }
    dispatch(setErrorState(null));
  }, []);

  return (
    <>
      <Helmet title="Unauthorized" />
      <section
        className="content-center bg-background-paper flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0"
        style={{
          height: "calc(100vh - 32px)",
        }}
      >
        <h1 className="text-xl mb-4">
          {user === null
            ? "Your session has expired"
            : "You are not authorized! 🔐"}
        </h1>
        <Button
          label={user === null ? "Back to Login" : "Back to Home"}
          onClick={() => {
            if (user === null) {
              dispatch(clearOtherStates());
              dispatch(clearCommonStates());
              dispatch(clearAuthStates());
              dispatch(clearUserStates());
              dispatch(clearReportStates());
              dispatch(clearDReportStates());
              dispatch(clearWeeklySummaryStates());
              dispatch(clearTaskStates());
              dispatch(clearMisaStates());
              dispatch(clearDocumentStates());
              dispatch(setErrorState(null));
              navigate(paths.LOGIN, { replace: true });
            } else {
              if ([UserRole.Admin, UserRole.Supervisor].includes(user.role)) {
                if (user.category.id === adminCat.id) {
                  navigate(
                    `${paths.CATEGORIES}/${adminCat.name}/${adminCat.id}`,
                    { replace: true }
                  );
                } else {
                  navigate(
                    `${paths.CATEGORIES}/${user.category.title}/${user.category.id}`,
                    {
                      replace: true,
                    }
                  );
                }
              } else {
                navigate(paths.COURSES_USER, { replace: true });
              }
            }
          }}
        />
      </section>
    </>
  );
}
